import { render, staticRenderFns } from "./CapituloCincoPage.vue?vue&type=template&id=1f17dcba"
import script from "./CapituloCincoPage.js?vue&type=script&lang=js&external"
export * from "./CapituloCincoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports